/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import React from 'react';
//utils
// import { sendErrorMessage } from 'utils/messages'
// styles
import injectSheet from 'react-jss';
import styles from 'pages/dashboard/account/adstxt/adstxtindicator/adstxtindicator_styles';



/* ========== ~~~~~~~~~~ TOGGLE : CHILD ~~~~~~~~~~ ========== */
// PRESENTATIONAL COMPONENT
// receives app state & actions as props from parent "_container" component
// this child component handles local state and uses props passed from parent to read/write application state when necessary
const AdsTxtIndicator = (props)=> {

    const missingValuesMessage = 'Your site has ads.txt values, but doesn\'t have all Insticator ads.txt values. Please review the values highlighted in red, and upload them to your global ads.txt file; then you can to verify again.'
    const notInstalledMessage = 'You don’t seem to have an ads.txt file on your domain root directory. Please download the Ads.txt file and make sure. that it is uploaded to your domain root directory, then try verifying again.';

    const renderMessage = ()=>{
        if(props.containsAdsTxt){
            if(props.installed){
                return <div>ads.txt installed correctly</div>
            }else{
                props.sendErrorMessage(missingValuesMessage);
                return <div>ads.txt not installed properly</div>
            }
        }else{
            props.sendErrorMessage(notInstalledMessage);
            return <div>Ads.txt is not installed on your site.</div>
        }
    };
    return (
        <div onClick={props.handleClick} className={`adstxtindicator ${props.classes.adstxtindicator} active-${props.on}`}>
            <div className={`indicator-ball installed-${!!props.installed}`}/> {renderMessage()}
        </div>
    );
};



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
// will be utilized in parent component after being infused with app state & actions
export default injectSheet(styles)(AdsTxtIndicator);